import React, { PureComponent } from 'react';
import PT from 'prop-types';
import InputRange from 'react-input-range';
import classes from './filterRangeSlider.css';

export default class FilterRangeSlider extends PureComponent {
  static propTypes = {
    value: PT.oneOfType([PT.number, PT.shape(
      { min: PT.number, max: PT.number },
    )]),
    minValue: PT.number.isRequired,
    maxValue: PT.number.isRequired,
    formatLabel: PT.func,
    onChange: PT.func,
    onChangeComplete: PT.func.isRequired,
    disabled: PT.bool,
    sliderLabel: PT.string,
    allowSameValues: PT.bool,
  };

  static defaultProps = {
    value: 0,
    formatLabel: value => `Wk${value}`,
    onChange: () => {},
    disabled: false,
    allowSameValues: true,
    sliderLabel: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || { min: props.minValue, max: props.maxValue },
    };
  }

  componentWillReceiveProps = newProps => {
    const { value: currentValue } = this.state;
    if (newProps.value && (
      newProps.value.max !== currentValue.max ||
      newProps.value.min !== currentValue.min)) {
      this.setState({ value: newProps.value });
    }
  }

  handleChange = value => {
    this.setState({ value });
    this.props.onChange(value);
  }

  render() {
    const { value } = this.state;
    const {
      minValue,
      maxValue,
      formatLabel,
      disabled,
      sliderLabel,
      allowSameValues,
    } = this.props;

    return (
      <div className={classes.filterRangeSliderWrapper}>
        <div className={classes.labelText}> {sliderLabel} </div>
        <div className={classes.sliderContainer}>
          <InputRange
            value={value}
            minValue={minValue}
            maxValue={maxValue}
            formatLabel={formatLabel}
            onChange={this.handleChange}
            onChangeComplete={this.props.onChangeComplete}
            disabled={disabled}
            allowSameValues={allowSameValues}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/FilterComponents/FilterRangeSlider.js